import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import VentilationHero from './components/VentilationHero';
import VentilationGrid from './components/VentilationGrid';
import VentilationFeatures from './components/VentilationFeatures';
import SEOHead from '@/components/feature/SEOHead';

const schema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Ventilation VMC Double Flux Neuenegg - CasaReNovaPlus",
  "provider": {
    "@type": "LocalBusiness",
    "name": "CasaReNovaPlus",
    "telephone": "+41797616282",
    "address": { "@type": "PostalAddress", "streetAddress": "Austrasse 95", "addressLocality": "Neuenegg", "addressRegion": "Fribourg", "postalCode": "3176", "addressCountry": "CH" },
    "geo": { "@type": "GeoCoordinates", "latitude": "46.233333", "longitude": "6.083333" },
    "openingHoursSpecification": [
      { "@type": "OpeningHoursSpecification", "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday"], "opens": "07:00", "closes": "19:00" },
      { "@type": "OpeningHoursSpecification", "dayOfWeek": ["Saturday","Sunday"], "opens": "00:00", "closes": "23:59" }
    ],
    "priceRange": "CHF"
  },
  "areaServed": ["Genève", "Meyrin", "Carouge", "Lancy", "Vernier", "Onex", "Lausanne", "Vaud", "Fribourg", "Valais", "Suisse Romande"],
  "description": "Installation VMC double flux, climatisation et ventilation à Genève. Récupération de chaleur 95%, air sain, économies 30%. Devis gratuit.",
  "serviceType": "Ventilation VMC double flux climatisation",
  "offers": { "@type": "Offer", "availability": "https://schema.org/InStock", "priceSpecification": { "@type": "PriceSpecification", "priceCurrency": "CHF", "description": "Devis gratuit" } },
  "url": `${import.meta.env.VITE_SITE_URL}/ventilation`
};

export default function Ventilation() {
  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="Ventilation VMC Neuenegg | Climatisation Double Flux Installation - CasaReNovaPlus"
        description="Installation VMC double flux et climatisation à Genève. Récupération chaleur 95%, air sain, économies 30% sur chauffage. Zehnder, Helios, Vallox. Intervention Meyrin, Carouge, Lancy. Devis gratuit."
        keywords="VMC double flux Genève, ventilation Genève, climatisation Genève, installation VMC Genève, VMC Zehnder Genève, qualité air intérieur Genève, ventilation mécanique contrôlée Genève, récupération chaleur Genève, VMC Meyrin Carouge, climatisation Lausanne Vaud, entretien VMC Genève, purification air Genève"
        canonical={`${import.meta.env.VITE_SITE_URL}/ventilation`}
        schema={schema}
      />
      <Header />
      <VentilationHero />
      <VentilationGrid />
      <VentilationFeatures />
      <Footer />
    </div>
  );
}
